var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card" }, [
    _c("div", { staticClass: "card-header" }, [
      _c("h4", [_vm._v(_vm._s(_vm.type))]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card-body" }, [
      _c("div", [
        _c("p", { staticClass: "text-muted" }, [
          _vm._v("Лиды в оплаты (за период)"),
        ]),
        _vm._v(" "),
        _c("p", [
          _c("strong", [_vm._v(_vm._s(_vm.data.total))]),
          _vm._v(" "),
          _c("i", { staticClass: "icon-fa icon-fa-arrow-right" }),
          _vm._v(" "),
          _c("strong", [_vm._v(_vm._s(_vm.data.confirmed))]),
          _vm._v(" ("),
          _c("strong", [
            _vm._v(
              _vm._s(
                Math.round(((_vm.data.confirmed * 100) / _vm.data.total) * 10) /
                  10
              ) + "\n            %"
            ),
          ]),
          _vm._v(")"),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row border" }, [
        _c("div", { staticClass: "col-md-6 border-right" }, [
          _c("p", [_vm._v("Оформили заказ")]),
          _vm._v(" "),
          _c("p", [_c("strong", [_vm._v(_vm._s(_vm.data.total))])]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6" }, [
          _c("p", [_vm._v("Отказ у менеджера (звонок)")]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [
              _vm._v(_vm._s(_vm.data.rejectedB4Requisites) + " ("),
              _c("strong", [
                _vm._v(
                  _vm._s(
                    Math.round(
                      ((_vm.data.rejectedB4Requisites * 100) / _vm.data.total) *
                        10
                    ) / 10
                  ) + " %"
                ),
              ]),
              _vm._v(")"),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row border" }, [
        _c("div", { staticClass: "col-md-6 border-right" }, [
          _c("p", [_vm._v("Выданы реквизиты на оплату")]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [
              _vm._v(_vm._s(_vm.data.total - _vm.data.rejectedB4Requisites)),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6" }, [
          _c("p", [_vm._v("Отказ от оплаты")]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [
              _vm._v(_vm._s(_vm.data.rejectedAfterRequisites) + " ("),
              _c("strong", [
                _vm._v(
                  _vm._s(
                    Math.round(
                      ((_vm.data.rejectedAfterRequisites * 100) /
                        (_vm.data.total - _vm.data.rejectedB4Requisites)) *
                        10
                    ) / 10
                  ) + " %"
                ),
              ]),
              _vm._v(")"),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row border" }, [
        _c("div", { staticClass: "col-md-6 border-right" }, [
          _c("p", [_vm._v("Оплачены")]),
          _vm._v(" "),
          _c("p", [_c("strong", [_vm._v(_vm._s(_vm.data.confirmed))])]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6" }),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }